// extracted by mini-css-extract-plugin
export default {"textInput":"Textarea-module__textInput___1rJQK"};